import React from 'react';
import { FaArrowRight } from 'react-icons/fa'
import { MdContactPage } from 'react-icons/md';
import { FaUserAlt } from 'react-icons/fa';
import { truncate } from '../../formatters';
import PropTypes from 'prop-types';
import { useTooltip } from '../../hooks';
import BaseTooltip from './BaseTooltip';

const propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

const LinkTooltip = ({ width, height }) => {
  const { currentLink: data, mosuePosition: { top, left } } = useTooltip();

  if (!data) return null;
  const centerPosition = left + (width / 2);
  const sideContentWidth = Math.max(120, Math.floor(width / 2) - 20);

  return (
    <BaseTooltip width={width} height={height}>
      <g transform={`translate(${centerPosition - 3} ${top + 20})`}>
        <text fontSize={12} x={-15} textAnchor="end" y={8} fontWeight="bold">
          #{data.source.page ? data.source.page : data.source.profile}
        </text>
        {data.source.page ?
          <MdContactPage y={-4} x={-15} size={15} style={{ fill: data.source.color }} /> :
          <FaUserAlt y={-1} x={-13} size={10} style={{ fill: data.source.color }} />
        }
        <FaArrowRight size={8} />
        <MdContactPage y={-4} x={10} size={15} style={{ fill: data.target.color }} />
        <text fontSize={12} x={25} y={8} fontWeight="bold">
          #{data.target.page}
        </text>
        <text fontSize={10} y={25} fontWeight="bold" textAnchor="middle" opacity={0.6} style={{ fontStyle: 'italic' }}>
          Total: {data.value}
        </text>
      </g>
      <g transform={`translate(${centerPosition - 10} ${top + 25})`} width={120}>
        <text y={50} textAnchor="end">
          {truncate(`${data.source.name} `, sideContentWidth)}
        </text>
        <text y={70} textAnchor="end">
          Impressions: {data.source.total}
        </text>
        {data.source.page !== null && (
          <text y={90} textAnchor="end">
            Slot: {data.source.slot}
          </text>
        )}
      </g>
      <line x1={centerPosition} y1={top + 55} x2={centerPosition} y2={top + 120} stroke='#6c757d' strokeOpacity={0.5} strokeWidth={0.5} />
      <g transform={`translate(${centerPosition} ${top + 25})`}>
        <text fontSize={12} x={10} y={50}>
          {truncate(`${data.target.name} `, sideContentWidth)}
        </text>
        <text fontSize={12}>
          <tspan x={10} y={70}>
            Impressions: {data.target.total}
            <tspan fontSize={9} style={{ fontStyle: 'italic' }}>
              ({(data.value / data.source.total * 100).toFixed()}%)
            </tspan>
          </tspan>
          {data.target.page !== 0 && (
            <tspan x={10} y={90}>
              Slot: {data.target.slot}
            </tspan>
          )}
        </text>
      </g>
    </BaseTooltip>
  )
}

LinkTooltip.propTypes = propTypes
LinkTooltip.defaultProps = {}

export default LinkTooltip;